import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { getOwnerTypeAndId } from '../../../auth/selectors';
import { getSelectedMembership } from '../../order/selectors';
import { setMembership } from '../../order/actions';
import { withPaginatedStoreHelpers, createPaginatedReduxStore } from '../../../common/paginatedReduxStore';

const storeControls = createPaginatedReduxStore({
  namespace: 'registerMemberships',
  buildUrl: (state) => {
    const owner = getOwnerTypeAndId(state);
    return `/${owner.type}/${owner.id}/memberships`;
  },
  limit: 12,
  httpVersion: 1,
});

const MembershipsListContainer = compose(
  connect(
    state => ({
      selectedMembership: getSelectedMembership(state),
    }),
    { selectMembership: setMembership }
  ),
  withPaginatedStoreHelpers(storeControls),
  withHandlers({
    isMembershipSelected: props => membership =>
      !!props.selectedMembership && props.selectedMembership.id === membership.id,
  }),
  lifecycle({
    componentDidMount() {
      this.props.openPage(1);
    },
  }),
);

export default MembershipsListContainer;
